namespace Solovis.Reports.Parts {

    export interface HtmlControlOptions extends Solovis.Reports.Parts.PartControlOptions {
        html: JQuery | HTMLElement | string;
        cleanHtml?: boolean;
        noClearBeforeRender?: boolean;
    }

    export class HtmlControl extends Solovis.Reports.Parts.PartControl {

        public html: JQuery | HTMLElement | string;
        public cleanHtml: boolean;
        public noClearBeforeRender: boolean;

        public persistedSettings: any;
        public getPersistedSettings: () => any;

        constructor(options: HtmlControlOptions) {
            super(options);

            var self = this;

            this.dataSets = null;
            this.html = options.settings.html;
            this.cleanHtml = options.settings.cleanHtml ? true : false;
            this.noClearBeforeRender = options.settings.noClearBeforeRender ? true : false;

            this.persistedSettings = options.persistedSettings ? options.persistedSettings : null;

            if (options.settings.getPersistedSettings) {
                this.getPersistedSettings = function () {
                    return options.settings.getPersistedSettings.call(self);
                };
            }
        }


        public doInitAsync() {
            var self = this;

            const newExperienceDependencies = Solovis.UX.Utils.isNewUxEnabled()
                ? Solovis.UX.Utils.loadNewExperienceDependencies()
                : Promise.resolve(true);

            newExperienceDependencies.then(() => {
                if (self.cleanHtml) {
                    Solovis.Rpc.invoke("~/ReportData/CleanHtml", { html: self.html },
                        function (response, success) {
                            if (success) {
                                self.html = response.result;
                            }
                            else {
                                self.html = "HTML cleaning failed.";
                            }

                            self.notifyInitComplete();
                        });
                }
                else {
                    self.notifyInitComplete();
                }
            });
        }

        public doRender() {
            var self = this;

            if (!this.noClearBeforeRender) {
                this.container.html("");
            }

            if (!this.dataSets) {
                return;
            }

            if (this.settings.render) {
                try {
                    this.settings.render.call(this);
                }
                catch (error) {
                    Solovis.log(error);

                    if (typeof error === "string") {
                        self.container.append(error);
                    }
                    else if (error && error.message && typeof error.message === "string") {
                        self.container.append(error.message);
                    }
                    else {
                        self.container.append("Unknown error when rendering content of HtmlControl.");
                    }
                }
            }
            else if (this.html) {
                this.container.html(this.html);
            }
        }

        public doDestroy() {
            if (this.settings.destroy) {
                try {
                    this.settings.destroy.call(this);
                }
                catch (error) {
                    console.log(error);
                }
            }
        }
    }

}